import ReactGa from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ampli } from '../../../../ampli/index';
import { IBanner } from '../../../../interfaces/Banner.interfaces';

import 'swiper/css/pagination';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

SwiperCore.use([Autoplay, Pagination]);

interface HomePageMainCarouselProps {
  carouselImages: IBanner[];
  pageType: 'home' | 'pdp' | 'olp' | 'new-product';
  position: 'top' | 'bottom';
}

export const MainCarousel = ({ carouselImages, pageType, position }: HomePageMainCarouselProps) => {
  const navigate = useNavigate();

  const handleGoToLandingPage = (landingUrl: string) => {
    // 앱 내부 링크
    if (landingUrl.includes(window.location.origin)) {
      const navigateUrl = landingUrl.trim().split(window.location.origin)[1].trim();

      navigate(navigateUrl);
    }

    // 그 외 (외부 링크)
    else {
      // 새 창으로 열어야 하는 경우
      // eslint-disable-next-line no-lonely-if
      if (landingUrl.includes('kakao')) {
        if (window.ReactNativeWebView) {
          postMessageToRN({ messageKey: 'link', messageParam: landingUrl });
        } else {
          window.open(landingUrl, '_blank', 'popup=yes, width=450, height=700, top=20, left=120');
        }
      }

      // 그 외 (다이렉트로 페이지 이동)
      else if (window.ReactNativeWebView) {
        postMessageToRN({ messageKey: 'link', messageParam: landingUrl });
      } else {
        window.location.href = landingUrl;
      }
    }
  };
  return (
    <Container id={'carousel-swiper-container'}>
      <Swiper
        slidesPerView={1}
        edgeSwipeDetection
        loop
        autoplay={{ delay: 3000 }}
        pagination={{
          type: 'fraction',
          renderFraction: (current, total) => {
            return `<div class="custom_swiper_fraction">
              <span class=${current}></span> /
              <span class=${total}></span>
            </div>`;
          },
        }}
      >
        {carouselImages.map((carouselImage) => (
          <CustomSwiperSlide
            key={carouselImage.id}
            data-swiper-autoplay={
              carouselImage.exposureTime && carouselImage.exposureTime > 0 ? carouselImage.exposureTime : 3000
            }
          >
            <CarouselImage
              src={carouselImage.url}
              alt={carouselImage.title}
              style={{
                backgroundColor: carouselImage.backgroundColor ?? 'white',
              }}
              onClick={() => {
                ampli.pvmClickMainCarousel({
                  carousel_title: carouselImage.title,
                  page_type: pageType,
                  position,
                });

                ReactGa.event('pvm_click_main_carousel', {
                  action: 'click',
                  category: 'carousel',
                  label: carouselImage.title,
                  page_type: pageType,
                  position,
                });

                if (carouselImage.landingUrl) {
                  handleGoToLandingPage(carouselImage.landingUrl);
                }
              }}
              loading={'lazy'}
            />
            <div className={'swiper-lazy-preloader'} />
          </CustomSwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

const Container = styled.section`
  width: 100%;
  height: auto;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  width: 100%;

  cursor: pointer;
`;

const CarouselImage = styled.img`
  width: 100%;

  object-fit: contain;

  cursor: pointer;
`;
